export const version = '14.5.3'
// Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.
